import { useState } from "react";
import { useModuleBEM } from "@b2bportal/core-themes";
import { Trans, useI18nContext } from "@hopper-b2b/i18n";
import styles from "./NotFoundPage.module.scss";
import { ErrorPage } from "@/components";
import { ActionButton } from "@/components/ActionButton";
import { ContactSupportDialogControlled } from "@/components/ContactSupportDialog";

export const NotFoundPage = () => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "NotFoundPage");
  const [isContactSupportOpen, setIsContactSupportOpen] = useState(false);

  return (
    <ErrorPage title={t("notFound.title")} className={cn("page")}>
      <p>{t("notFound.description")}</p>
      <p>
        <Trans
          i18nKey="notFound.additionalInfo"
          components={{
            contactLink: (
              <button
                onClick={() => setIsContactSupportOpen(true)}
                className={cn("contact-link")}
              />
            ),
          }}
        />
      </p>
      <p>{t("notFound.suggestion")}</p>
      <div className={cn("buttons")}>
        <ActionButton
          className={cn("homeButton")}
          to="/"
          message={t("notFound.backToHome")}
          target="_self"
        />
      </div>
      <ContactSupportDialogControlled
        open={isContactSupportOpen}
        onClose={() => setIsContactSupportOpen(false)}
      />
    </ErrorPage>
  );
};
